import React from "react";
import Modal from "@mui/material/Modal";
import ButtonComponent from "../ButtonComponent";
// import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { COLORS } from "../../lib/colors";
import { useTranslation } from "react-i18next";
import classes from "./index.module.scss";
import CancelIcon from "@mui/icons-material/Cancel";

export default function Index({
  handleClose,
  open,
  title,
  closeBtn,
  confirmBtn,
  handleOk,
  children,
  loadingRequest,
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      onEscapeKeyDown={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.mainContainer}>
        <div className={classes.paper}>
          {closeBtn && (
            <CancelIcon onClick={handleClose} color="error" fontSize="large" />
          )}
          <div className={classes.title}>
            <h3>{title}</h3>
          </div>
          <div>{children}</div>

          <div className={classes.actionBtn}>
            {/* {closeBtn && (
              <ButtonComponent
                backgroundColor={COLORS.error}
                textColor={COLORS.red}
                // width="5%"
                icon={<CloseIcon />}
                onClick={handleClose}
              >
                {t("ModalComponent.closeBtn")}
              </ButtonComponent>
            )} */}
            {confirmBtn && (
              <ButtonComponent
                backgroundColor={COLORS.purple}
                // width="5%"
                icon={<CheckIcon />}
                onClick={handleOk}
                loading={loadingRequest}
              >
                {t("ModalComponent.confirmBtn")}
              </ButtonComponent>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
